// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.title_DcqLl {
    font-size: 1.3rem;
    font-weight: 600;
    color: var(--_10a37f-background);
    margin-bottom: 15px;
    padding-bottom: 8px;
}

.containerForm_voWI5 {
    background: var(--white-background);
    padding: 15px;
    border-radius: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/contacts/billingDetails.module.css"],"names":[],"mappings":";AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,aAAa;IACb,kBAAkB;AACtB","sourcesContent":["\n.title {\n    font-size: 1.3rem;\n    font-weight: 600;\n    color: var(--_10a37f-background);\n    margin-bottom: 15px;\n    padding-bottom: 8px;\n}\n\n.containerForm {\n    background: var(--white-background);\n    padding: 15px;\n    border-radius: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `title_DcqLl`,
	"containerForm": `containerForm_voWI5`
};
export default ___CSS_LOADER_EXPORT___;
